import xlsxExport from '../../shared/xlsxExport/xlsxExport';
import { ConfigurationColumnDefinitions } from './columnDefinitions';
import { SheetExportTypes } from '@common/xlsxExport/xlsxExport.constants';
import { importValidationColumnDefinition, periodColumnDefinition } from '../../shared/columnDefinitions';

const getColumnDefinitionsWithImportValidation = (columnDefs, entities) => {
  const hasImportValidationsErrors = entities.some(entity => entity.importStatusDetail === -1);

  return hasImportValidationsErrors
    ? [importValidationColumnDefinition, periodColumnDefinition, ...columnDefs]
    : [periodColumnDefinition, ...columnDefs];
};


export default async ({
  configurationSettings,
  categories,
  periodName,
  shouldDisplayZero,
  hideDecimals,
  negativeMinus,
  environmentSuffix,
  callback: dispatchAction,
}, callback) => {
  configurationSettings.companyCodes.forEach(
    companyCode => companyCode.periodName = periodName
  );
  configurationSettings.bookToTaxDifferences.forEach(
    bookToTaxDifference => {
      bookToTaxDifference.periodName = periodName;
      bookToTaxDifference.countryTaxTypes = bookToTaxDifference.countryTaxTypes.join(',');
      bookToTaxDifference.connections = bookToTaxDifference.connections.join(',');
      bookToTaxDifference.excludedCompanyCodes = bookToTaxDifference.excludedCompanyCodes.join(',');
    }
  );
  configurationSettings.taxRates.forEach(
    taxRate => taxRate.periodName = periodName
  );
  configurationSettings.taxAccounting.forEach(
    taxAccounting => taxAccounting.periodName = periodName
  );

  await xlsxExport({
    sheetData: [
      {
        name: 'Company Codes',
        columnDefinitions: [periodColumnDefinition].concat(
          ConfigurationColumnDefinitions.companyCodesColumnDefinition
        ),
        data: configurationSettings.companyCodes,
        type: SheetExportTypes.GRID,
        options: {
          shouldDisplayZero,
          hideDecimals,
          negativeMinus,
        },
      },
      {
        name: 'Business Units',
        columnDefinitions: [periodColumnDefinition].concat(
          ConfigurationColumnDefinitions.businessUnitsColumnDefinition
        ),
        data: configurationSettings.businessUnits,
        type: SheetExportTypes.GRID,
        options: {
          shouldDisplayZero,
          hideDecimals,
          negativeMinus,
        },
      },
      {
        name: 'Legal Entities',
        columnDefinitions: [periodColumnDefinition].concat(
          ConfigurationColumnDefinitions.legalEntitiesWithSourceColumnDefinitions
        ),
        data: configurationSettings.legalEntities,
        type: SheetExportTypes.GRID,
        options: {
          shouldDisplayZero,
          hideDecimals,
          negativeMinus,
        },
      },
      {
        name: 'Book to Tax Differences',
        columnDefinitions: [periodColumnDefinition].concat(
          ConfigurationColumnDefinitions.bookToTaxDifferencesColumnDefinition
        ),
        data: configurationSettings.bookToTaxDifferences,
        type: SheetExportTypes.GRID,
        options: {
          shouldDisplayZero,
          hideDecimals,
          negativeMinus,
        },
      },
      {
        name: 'Tax Rates',
        columnDefinitions: [periodColumnDefinition].concat(
          ConfigurationColumnDefinitions.taxRatesColumnDefinition
        ),
        data: configurationSettings.taxRates,
        type: SheetExportTypes.GRID,
        options: {
          shouldDisplayZero,
          hideDecimals,
          negativeMinus,
        },
      },
      {
        name: 'Obligations',
        columnDefinitions: [periodColumnDefinition].concat(
          ConfigurationColumnDefinitions.obligationsColumnDefinition
        ),
        data: configurationSettings.obligations,
        type: SheetExportTypes.GRID,
        options: {
          shouldDisplayZero,
          hideDecimals,
          negativeMinus,
        },
      },
      {
        name: 'Tax Booking Entities',
        columnDefinitions: getColumnDefinitionsWithImportValidation(
          ConfigurationColumnDefinitions.taxBookingEntitiesColumnDefinition,
          configurationSettings.taxBookingEntities
        ),
        data: configurationSettings.taxBookingEntities,
        type: SheetExportTypes.GRID,
        options: {
          shouldDisplayZero,
          hideDecimals,
          negativeMinus,
        },
      },
      {
        name: 'TLS Accounts',
        columnDefinitions: [periodColumnDefinition].concat(
          ConfigurationColumnDefinitions.tlsAccountsWithTagsColumnDefinitions(categories)
        ),
        data: configurationSettings.tlsAccounts,
        type: SheetExportTypes.GRID,
        options: {
          shouldDisplayZero,
          hideDecimals,
          negativeMinus,
        },
      },
      {
        name: 'Tax Accounting',
        columnDefinitions: [periodColumnDefinition].concat(
          ConfigurationColumnDefinitions.taxAccountingColumnDefinition
        ),
        data: configurationSettings.taxAccounting,
        type: SheetExportTypes.GRID,
        options: {
          shouldDisplayZero,
          hideDecimals,
          negativeMinus,
        },
      },
      {
        name: 'Users',
        columnDefinitions: ConfigurationColumnDefinitions.usersColumnDefinition,
        data: configurationSettings.users,
        type: SheetExportTypes.GRID,
        options: {
          shouldDisplayZero,
          hideDecimals,
          negativeMinus,
        },
      },
      {
        name: 'Subledger Map',
        columnDefinitions: [periodColumnDefinition].concat(ConfigurationColumnDefinitions.subledgerMapColumnDefinition),
        data: configurationSettings.subledgerMap,
        type: SheetExportTypes.GRID,
        options: {
          shouldDisplayZero,
          hideDecimals,
          negativeMinus,
        },
      },
      {
        name: 'Currency',
        columnDefinitions: ConfigurationColumnDefinitions.currencyColumnDefinition,
        data: configurationSettings.currency,
        type: SheetExportTypes.GRID,
        options: {
          shouldDisplayZero,
          hideDecimals,
          negativeMinus,
        },
      },
      {
        name: 'Periods',
        columnDefinitions: ConfigurationColumnDefinitions.periodsColumnDefinitions,
        data: configurationSettings.periods,
        type: SheetExportTypes.GRID,
        options: {
          shouldDisplayZero,
          hideDecimals,
          negativeMinus,
        },
      },
      {
        name: 'Currency Conversion Rates',
        columnDefinitions: ConfigurationColumnDefinitions.currencyConversionRateColumnDefinitions,
        data: configurationSettings.currencyConversionRates,
        type: SheetExportTypes.GRID,
        options: {
          shouldDisplayZero,
          hideDecimals,
          negativeMinus,
        },
      },
    ],
    metadata: {
      disableHeaderRendering: true,
      fileName: `TLS_Configuration_${periodName}${environmentSuffix}`,
    },
  });

  if (dispatchAction) {
    dispatchAction();
  }

  if (callback) {
    callback();
  }
};
